import React from "react";
import { Link } from "react-router-dom";
import { TspCard } from "../../../components/primitives";

export default function ActiveJourneysCard({ journeys }) {
  return (
    <TspCard
      title="Active Journeys"
      action={
        <Link to="/tsp/journeys" className="tsp-view-all-link">
          View All &gt;
        </Link>
      }
    >
      {journeys.length === 0 && <p className="tsp-muted-text">No active journeys right now.</p>}
      <ul className="tsp-active-journeys-list">
        {journeys.map((journey) => (
          <li key={journey.id}>
            <span className="tsp-journey-avatar" style={{ backgroundColor: journey.color }}>
              {journey.initial}
            </span>
            <span className="tsp-journey-info">
              <span className="tsp-journey-name">{journey.name}</span>
              <span className="tsp-journey-meta">
                {journey.team} · {journey.city}
              </span>
            </span>
            <span className="tsp-journey-progress">
              {journey.progress}
              <span className="tsp-journey-days">{journey.daysLeft}</span>
            </span>
          </li>
        ))}
      </ul>
    </TspCard>
  );
}
